import React, { FC, useEffect, useState } from 'react';
import { useStyles } from './styles';
import { Controller, useForm } from 'react-hook-form';
import { FormControl, Grid, InputLabel, MenuItem, Select, TextField } from '@material-ui/core';
import { LicenseFormData } from './types';
import { UpgradeLicenseFormInput } from '../UpgradeLicenseForm';
import { useStore } from 'hooks/useRootStore';
import { useQuery } from 'react-query';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { toFormatDate, toFormatSum } from 'utils';
const LicenseForm: FC<LicenseFormData> = ({
  indexValue,
  selectedValue,
  user,
  discountAddon,
  discountCore,
  payment,
  edu,
  addonPeriod,
  corePeriod,
  userAddon,
}) => {
  const classes = useStyles();

  const {
    upgradeLicenseStore: { upgradelicenseplan, getUpgradeLicenseInfo, previousLicense, getCoreInfo, lisenceInfo },
    notificationStore: { openNotification },
  } = useStore();
  const duration = previousLicense?.paymentPeriodUsersCore
    ? previousLicense?.paymentPeriodUsersCore === 'yearly'
      ? 'yearly'
      : 'monthly'
    : previousLicense?.paymentPeriodUsersCore === 'monthly'
    ? 'monthly'
    : 'yearly';
  const [addonPer, setAdddonPer] = useState<string>('yearly');
  const [corePer, setCorePer] = useState<string>(duration);
  const [checkedu, setCheckEdu] = useState<string>('no');
  const [paymentMethod, setPaymentMethod] = useState<any>('card');
  const [codeCore, setCodeCore] = useState('');
  const [codeAddon, setCodeAddon] = useState('');
  const [users, setUsers] = useState<number>(0);
  const [usersAddon, setUserAddon] = useState<number>(0);
  const { control } = useForm<UpgradeLicenseFormInput>();
  edu(checkedu);
  addonPeriod(addonPer);
  corePeriod(corePer);
  payment(paymentMethod);
  discountCore(codeCore);
  discountAddon(codeAddon);
  user(users);
  userAddon(usersAddon);

  const getClientCoreInfo = useQuery('getClientCoreInfo', () => getCoreInfo(), {
    onError: () => openNotification('error', `Can't get previous license info`),
  });
  const getUpgradeLicense = useQuery('getUpgradeLicense', () => getUpgradeLicenseInfo(), {
    onError: () => openNotification('error', `Can't get upgrade license info`),
  });

  useEffect(() => {
    if (previousLicense?.addon === 'no') {
      const totalUsers = users + (previousLicense?.numberOfUsersCore || 0);
      setUserAddon(totalUsers);
    } else {
      setUserAddon(users);
    }
  }, [users, previousLicense?.addon, previousLicense?.numberOfUsersCore]);
  useAppPreloader(getClientCoreInfo.isLoading);

  const dateCalc = () => {
    const currdate = new Date();

    if (corePer === 'monthly' && indexValue === 'one') {
      const finalDate = new Date(currdate.setDate(currdate.getDate() + 30));
      return finalDate.toISOString().split('T')[0];
    } else {
      if (lisenceInfo?.aclPaymentDueDate === '') {
        const finalDate = new Date(currdate.setDate(currdate.getDate() + 365));
        return finalDate.toISOString().split('T')[0];
      } else {
        const finalDates = previousLicense?.dateUsersCoreExpire || null; // Assigning null if undefined
        return finalDates;
      }
    }
  };

  const currentDate = () => {
    const currdate = new Date();
    const finalDate = new Date(new Date().setDate(currdate.getDate()));
    return finalDate.toISOString().split('T')[0];
  };

  return (
    <>
      <Grid container className={classes.featureSelect}>
        {indexValue === 'one' && (
          <Grid className={classes.selction1} item xs={6}>
            <Controller
              name='paymentperCore'
              defaultValue={corePer}
              control={control}
              render={({ field, fieldState: { invalid } }) => (
                <Grid container>
                  <FormControl className={classes.input}>
                    <InputLabel>Payment period:</InputLabel>
                    <Select
                      {...field}
                      value={corePer}
                      className={classes.input}
                      onChange={(evt: any) => {
                        setCorePer(evt.target.value);
                        if (corePer === 'yearly' && paymentMethod === 'invoice') {
                          setPaymentMethod('card');
                        }
                      }}>
                      <MenuItem disabled={previousLicense?.paymentPeriodUsersCore === 'yearly'} value='monthly'>
                        Monthly
                      </MenuItem>
                      <MenuItem disabled={previousLicense?.paymentPeriodUsersCore === 'monthly'} value='yearly'>
                        Yearly
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              )}
            />
          </Grid>
        )}
        {indexValue === 'two' && (
          <Grid className={classes.selction1} item xs={6}>
            <Controller
              name='paymentperAddOn'
              defaultValue={addonPer}
              control={control}
              render={({ field, fieldState: { invalid } }) => (
                <Grid container>
                  <FormControl className={classes.inputText}>
                    <InputLabel>Payment period:</InputLabel>
                    <Select
                      {...field}
                      disabled
                      value={addonPer}
                      className={classes.input}
                      onChange={(evt: any) => {
                        setAdddonPer(evt.target.value);
                        if (addonPer === 'yearly' && paymentMethod === 'invoice') {
                          setPaymentMethod('card');
                        }
                      }}>
                      <MenuItem disabled={previousLicense?.paymentPeriodUsersAddon === 'yearly'} value='monthly'>
                        Monthly
                      </MenuItem>
                      <MenuItem disabled={previousLicense?.paymentPeriodUsersAddon === 'monthly'} value='yearly'>
                        Yearly
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              )}
            />
          </Grid>
        )}
        {indexValue === 'one' && corePer === 'monthly' && (
          <Grid className={classes.selction2} item xs={6}>
            <Controller
              name='paymentMethod'
              defaultValue='card'
              control={control}
              render={({ field, fieldState: { invalid } }) => (
                <Grid container>
                  <FormControl className={classes.input}>
                    <InputLabel>Payment method:</InputLabel>
                    <Select defaultValue='card' onChange={(e: any) => setPaymentMethod(e.target.value)}>
                      <MenuItem value='card'> Credit Card</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              )}
            />
          </Grid>
        )}
        {indexValue === 'one' && corePer === 'yearly' && (
          <Grid className={classes.selction2} item xs={6}>
            <Controller
              name='paymentMethod'
              defaultValue={paymentMethod}
              control={control}
              render={({ field, fieldState: { invalid } }) => (
                <Grid container>
                  <FormControl className={classes.input}>
                    <InputLabel>Payment method:</InputLabel>
                    <Select defaultValue={paymentMethod} onChange={(e: any) => setPaymentMethod(e.target.value)}>
                      <MenuItem value='card'>Credit Card</MenuItem>
                      <MenuItem value='invoice'>Invoice Via Email</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              )}
            />
          </Grid>
        )}
        {indexValue === 'two' && (
          <Grid className={classes.selction2} item xs={6}>
            <Controller
              name='paymentMethod'
              defaultValue={corePer === 'monthly' ? 'card' : paymentMethod}
              control={control}
              render={({ field, fieldState: { invalid } }) => (
                <Grid container>
                  <FormControl className={classes.inputText}>
                    <InputLabel>Payment method:</InputLabel>
                    <Select disabled defaultValue={corePer === 'monthly' ? 'card' : paymentMethod}>
                      <MenuItem value='card'>Credit Card</MenuItem>
                      <MenuItem value='invoice'>Invoice Via Email</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              )}
            />
          </Grid>
        )}
        {indexValue === 'one' && (
          <Grid className={`${classes.selction1}`} item xs={6}>
            <Controller
              name='organization'
              defaultValue={checkedu}
              control={control}
              render={({ field, fieldState: { invalid } }) => (
                <Grid container>
                  <FormControl className={classes.input}>
                    <InputLabel>Edu/Non-Profit/Gov Entity:</InputLabel>
                    <Select {...field} value={checkedu} onChange={(event: any) => setCheckEdu(event.target.value)}>
                      <MenuItem value='no'>No</MenuItem>
                      <MenuItem value='yes'>Yes</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              )}
            />
          </Grid>
        )}
        {indexValue === 'two' && (
          <Grid className={`${classes.selction1}`} item xs={6}>
            <Controller
              name='organization'
              defaultValue={checkedu}
              control={control}
              render={({ field, fieldState: { invalid } }) => (
                <Grid container>
                  <FormControl className={classes.inputText}>
                    <InputLabel>Edu/Non-Profit/Gov Entity:</InputLabel>
                    <Select
                      disabled
                      {...field}
                      value={checkedu}
                      onChange={(event: any) => setCheckEdu(event.target.value)}>
                      <MenuItem value='no'>No</MenuItem>
                      <MenuItem value='yes'>Yes</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              )}
            />
          </Grid>
        )}
        {upgradelicenseplan.map(
          (prices) =>
            indexValue === 'two' &&
            prices.name === 'Add-On' &&
            selectedValue === 'yearly' &&
            checkedu === 'yes' && (
              <Grid className={classes.selction2} item xs={6}>
                <Controller
                  name='pricingAddOn'
                  defaultValue='e_year'
                  control={control}
                  render={({ field, fieldState: { invalid } }) => (
                    <Grid container>
                      <TextField
                        disabled
                        className={classes.inputText}
                        label='Cost:'
                        placeholder={`$${toFormatSum(prices.edu_paid_yearly)} USD/user`}
                        defaultValue={`$${toFormatSum(prices.edu_paid_yearly)} USD/user`}
                      />
                    </Grid>
                  )}
                />
              </Grid>
            )
        )}
        {upgradelicenseplan.map(
          (prices) =>
            indexValue === 'two' &&
            prices.name === 'Add-On' &&
            selectedValue === 'yearly' &&
            checkedu === 'no' && (
              <Grid className={classes.selction2} item xs={6}>
                <Controller
                  name='pricingAddOn'
                  defaultValue='p_year'
                  control={control}
                  render={({ field, fieldState: { invalid } }) => (
                    <Grid container>
                      <TextField
                        disabled
                        className={classes.inputText}
                        label='Cost:'
                        placeholder={`$${prices.price_paid_yearly} USD/user`}
                        defaultValue={`$${prices.price_paid_yearly} USD/user`}
                      />
                    </Grid>
                  )}
                />
              </Grid>
            )
        )}
        {upgradelicenseplan.map(
          (prices) =>
            indexValue === 'one' &&
            prices.name === 'Core' &&
            corePer === 'yearly' &&
            checkedu === 'yes' && (
              <Grid className={classes.selction2} item xs={6}>
                <Controller
                  name='pricingCore'
                  defaultValue='e_year'
                  control={control}
                  render={({ field, fieldState: { invalid } }) => (
                    <Grid container>
                      <TextField
                        disabled
                        className={classes.inputText}
                        label='Cost:'
                        placeholder={`$${prices.edu_paid_yearly} USD/user`}
                        defaultValue={`$${prices.edu_paid_yearly} USD/user`}
                      />
                    </Grid>
                  )}
                />
              </Grid>
            )
        )}
        {upgradelicenseplan.map(
          (prices) =>
            indexValue === 'one' &&
            prices.name === 'Core' &&
            corePer === 'yearly' &&
            checkedu === 'no' && (
              <Grid className={classes.selction2} item xs={6}>
                <Controller
                  name='pricingCore'
                  defaultValue='p_year'
                  control={control}
                  render={({ field, fieldState: { invalid } }) => (
                    <Grid container>
                      <TextField
                        disabled
                        className={classes.inputText}
                        label='Cost:'
                        placeholder={`$${prices.price_paid_yearly} USD/user`}
                        defaultValue={`$${prices.price_paid_yearly} USD/user`}
                      />
                    </Grid>
                  )}
                />
              </Grid>
            )
        )}
        {upgradelicenseplan.map(
          (prices) =>
            indexValue === 'one' &&
            prices.name === 'Core' &&
            corePer === 'monthly' &&
            checkedu === 'yes' && (
              <Grid className={classes.selction2} item xs={6}>
                <Controller
                  name='pricingCore'
                  defaultValue='e_year'
                  control={control}
                  render={({ field, fieldState: { invalid } }) => (
                    <Grid container>
                      <TextField
                        disabled
                        className={classes.inputText}
                        label='Cost:'
                        placeholder={`$${prices.edu_paid_monthly} USD/user`}
                        defaultValue={`$${prices.edu_paid_monthly} USD/user`}
                      />
                    </Grid>
                  )}
                />
              </Grid>
            )
        )}
        {upgradelicenseplan.map(
          (prices) =>
            indexValue === 'one' &&
            prices.name === 'Core' &&
            corePer === 'monthly' &&
            checkedu === 'no' && (
              <Grid className={classes.selction2} item xs={6}>
                <Controller
                  name='pricingCore'
                  defaultValue='p_year'
                  control={control}
                  render={({ field, fieldState: { invalid } }) => (
                    <Grid container>
                      <TextField
                        disabled
                        className={classes.inputText}
                        label='Cost:'
                        placeholder={`$${prices.price_paid_monthly} USD/user`}
                        defaultValue={`$${prices.price_paid_monthly} USD/user`}
                      />
                    </Grid>
                  )}
                />
              </Grid>
            )
        )}
        {getUpgradeLicense.isLoading && (
          <Grid className={classes.selction2} item xs={6}>
            <Controller
              name='pricingCore'
              defaultValue='p_year'
              control={control}
              render={({ field, fieldState: { invalid } }) => (
                <Grid container>
                  <TextField
                    disabled
                    className={classes.inputText}
                    label='Cost:'
                    placeholder='$0.00 USD/user'
                    defaultValue='$0.00 USD/user'
                  />
                </Grid>
              )}
            />
          </Grid>
        )}

        {indexValue === 'one' && (
          <Grid className={classes.selction1} item xs={6}>
            <Controller
              name='numberOfUserAccountsCore'
              control={control}
              rules={{ required: true }}
              render={({ field, fieldState: { invalid } }) => (
                <Grid container>
                  <FormControl className={classes.input}>
                    <TextField
                      onChange={(events: any) => {
                        setUsers(Number(events.target.value.replace(/[^0-9.-]+/g, '')));
                      }}
                      defaultValue={users}
                      // value={toFormatSum(users)}
                      placeholder='1'
                      error={users < 1}
                      helperText={users < 1 ? 'Number must be positive and greater than 0' : ' '}
                      inputProps={{
                        pattern: '[0-9]*',
                        min: 1,
                      }}
                      label='Total Number Of Users:'
                      variant='standard'
                    />
                  </FormControl>
                </Grid>
              )}
            />
          </Grid>
        )}
        {indexValue === 'two' && (
          <Grid className={classes.selction1} item xs={6}>
            <Controller
              name='numberOfUserAccountsAddOn'
              control={control}
              rules={{ required: true }}
              render={({ field, fieldState: { invalid } }) => (
                <Grid container>
                  <FormControl className={classes.input}>
                    <TextField
                      onChange={(events: any) => {
                        setUserAddon(events.target.value);
                      }}
                      defaultValue={usersAddon}
                      placeholder='1'
                      className={classes.inputText}
                      disabled
                      error={usersAddon < 1}
                      helperText={usersAddon < 1 ? 'Number must be positive and greater than 0' : ' '}
                      inputProps={{
                        pattern: '[0-9]*',
                        min: 1,
                      }}
                      label='Total Number Of Users:'
                      variant='standard'
                    />
                  </FormControl>
                </Grid>
              )}
            />
          </Grid>
        )}
        {indexValue === 'one' && (
          <Grid className={classes.selction2} item xs={6}>
            <Controller
              name='discountCodeCore'
              defaultValue={codeCore}
              control={control}
              render={({ field, fieldState: { invalid } }) => (
                <Grid container>
                  <FormControl className={classes.input}>
                    <TextField
                      defaultValue={codeCore}
                      label='Discount code (optional):'
                      variant='standard'
                      onChange={(e: any) => setCodeCore(e.target.value)}
                    />
                  </FormControl>
                </Grid>
              )}
            />
          </Grid>
        )}
        {indexValue === 'two' && (
          <Grid className={classes.selction2} item xs={6}>
            <Controller
              name='discountCodeAddOn'
              defaultValue={codeCore}
              control={control}
              render={({ field, fieldState: { invalid } }) => (
                <Grid container>
                  <FormControl className={classes.inputText}>
                    <TextField
                      disabled
                      defaultValue={codeCore}
                      label='Discount code (optional):'
                      variant='standard'
                      onChange={(e: any) => setCodeAddon(e.target.value)}
                    />
                  </FormControl>
                </Grid>
              )}
            />
          </Grid>
        )}
        {indexValue === 'three' ? (
          ' '
        ) : (
          <Grid className={classes.dateDisplay} item xs={6}>
            <Controller
              name='startDate'
              control={control}
              defaultValue={`${toFormatDate(currentDate())}`}
              rules={{ required: true }}
              render={({ field, fieldState: { invalid } }) => (
                <Grid container>
                  <FormControl className={classes.input}>
                    <TextField
                      label='Subscription Start:'
                      variant='standard'
                      defaultValue={`${toFormatDate(currentDate())}`}
                      className={classes.inputText}
                      placeholder={`${toFormatDate(currentDate())}`}
                      value={toFormatDate(currentDate())}
                      disabled
                    />
                  </FormControl>
                </Grid>
              )}
            />
          </Grid>
        )}
        {indexValue === 'one' && (
          <Grid className={classes.dateDisplay1} item xs={6}>
            <Controller
              name='endDate'
              control={control}
              defaultValue={`${toFormatDate(dateCalc())}`}
              rules={{ required: true }}
              render={({ field, fieldState: { invalid } }) => (
                <Grid container>
                  <FormControl className={classes.input}>
                    <TextField
                      defaultValue={`${toFormatDate(dateCalc())}`}
                      className={classes.inputText}
                      value={toFormatDate(dateCalc())}
                      disabled
                      label='Subscription Renews:'
                      variant='standard'
                    />
                  </FormControl>
                </Grid>
              )}
            />
          </Grid>
        )}
        {indexValue === 'two' && (
          <Grid className={classes.dateDisplay1} item xs={6}>
            <Controller
              name='endDate'
              control={control}
              defaultValue={`${toFormatDate(dateCalc())}`}
              rules={{ required: true }}
              render={({ field, fieldState: { invalid } }) => (
                <Grid container>
                  <FormControl className={classes.input}>
                    <TextField
                      defaultValue={`${toFormatDate(dateCalc())}`}
                      className={classes.inputText}
                      value={toFormatDate(dateCalc())}
                      disabled
                      label='Subscription Renews:'
                      variant='standard'
                    />
                  </FormControl>
                </Grid>
              )}
            />
          </Grid>
        )}
      </Grid>
    </>
  );
};
export default LicenseForm;
